module.exports = __webpack_public_path__ + "img/logo.c4050df6.png";